// utils.js
export const fluidSizes = (minSize, maxSize = null, unit = 'px', minWidth = 320, maxWidth = 2000) => {
  if (typeof minSize === 'string' && minSize.includes(',')) {
    [minSize, maxSize] = minSize.split(',').map(size => size.trim());
    if (minSize.endsWith(unit)) minSize = minSize.slice(0, -unit.length);
    if (maxSize.endsWith(unit)) maxSize = maxSize.slice(0, -unit.length);
  }

  if (!maxSize) {
    throw new Error('Both minSize and maxSize are required');
  }

  if (unit === 'px' || !unit) {
    return `clamp(${minSize}px, ${minSize}px + (${maxSize} - ${minSize}) * ((100vw - ${minWidth}px) / (${maxWidth} - ${minWidth})), ${maxSize}px)`;
  } else {
    return `clamp(${minSize}${unit}, calc(${minSize}${unit} + (${maxSize}${unit} - ${minSize}${unit}) * ((100vw - ${minWidth}px) / (${maxWidth} - ${minWidth}))), ${maxSize}${unit})`;
  }
};
